<scaffold-dialog
  [showCloseButton]="showCloseButton"
  (close)="handleClick()"
  [title]="title"
  [fit]="fit"
  [fullHeight]="fullHeight"
  [size]="size"
>
  <div scaffoldDialogBody>
    <div class="date-modal-top-row">
      <label class="data-modal-label">
        <ng-container *ngIf="text; else defaulttext">{{ text }}</ng-container>
        <ng-template #defaulttext>
          {{ useRange ? "Select Dates" : "Select a Date" }}
        </ng-template>
      </label>
    </div>

    <ng-container *ngIf="useRange">
      <div class="date-modal-range-dates-container">
        <div class="date-modal-range-date-container">
          <div><label class="data-modal-label">From</label></div>

          <p-datepicker
            fluid
            appendTo="body"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [(ngModel)]="fromDate"
            placeholder="Start Date"
            (onSelect)="updateFromDate($event)"
          />
        </div>
        <div class="date-modal-range-date-container">
          <div><label class="data-modal-label">Till</label></div>
          <p-datepicker
            fluid
            appendTo="body"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [(ngModel)]="tillDate"
            placeholder="End Date"
            (onSelect)="updateTillDate($event)"
          />
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!useRange">
      <p-datepicker
        fluid
        appendTo="body"
        [iconDisplay]="'input'"
        [showIcon]="true"
        [(ngModel)]="date"
        placeholder="Select Date"
        (onSelect)="updateDate($event)"
      />
    </ng-container>
  </div>

  <div scaffoldDialogButtons>
    <button pButton severity="secondary" (click)="handleClick()">
      {{ declineMessage || "cancel" | translation }}
    </button>
    <button
      pButton
      severity="primary"
      cdkFocusInitial
      (click)="handleClick(true)"
    >
      {{ confirmMessage || "submit" | translation }}
    </button>
  </div>
</scaffold-dialog>
